import { Switch, Route } from 'react-router';

import { EmployeesTable } from './employees/table';
import { PositionsTable } from './positions/table';
import { LevelsTable } from './levels/table';
import { OrgStructureViewTree } from './views/tree';
import { OrgStructureViewTable } from './views/table';


export const OrgStructureDomain = () => {
  return (
    <Switch>
      <Route exact path="/org-structure/tree/" component={OrgStructureViewTree} />
      <Route exact path="/org-structure/table/" component={OrgStructureViewTable} />

      <Route exact path="/org-structure/levels/" component={LevelsTable} />
      <Route exact path="/org-structure/positions/" component={PositionsTable} />
      <Route exact path="/org-structure/employees/" component={EmployeesTable} />
    </Switch>
  );
};
